<template>
  <section class="company-intro">
    <div class="container">
      <h2 class="section-title">
        <span class="title-text">公司简介</span>
        <span class="title-line"></span>
      </h2>

      <div class="intro-content">
        <p class="intro-text">
          智学堂是一家专注于<span style="color: #ff6700;font-weight: bolder;padding-left: 10px;padding-right: 10px">车载测试技术培训</span>的互联网教育企业。
          公司秉承"<el-text type="primary">科技驱动教育，创新引领未来</el-text>"的理念，
          致力于培养符合汽车行业需求的高素质车载测试人才，助力学员实现高质量就业与职业发展。
        </p>

        <p class="intro-text">
          核心课程"车载测试零基础保就业课程"涵盖智能座舱、智能驾驶、车载网络诊断、车联网、车载自动化测试等全栈技术方向，
          共15个核心章节、281课时，配备真实车载仿真系统实操练习。
          已为蔚来、理想、吉利、赛力斯、比亚迪、博世、德赛西威等<span style="color: #ff6700;font-weight: bold">知名车企及零部件企业累计培养车载测试人才300余名</span>，深受企业认可。
        </p>
        <p class="intro-text">
          报名即签订就业保障协议，未按保障薪资就业退还学费。未来，智学堂将继续深耕车载测试教育，
          为更多学员提供优质的学习平台，助力中国智能汽车产业的人才培养！
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
// 组件内部无需额外逻辑，仅承载公司简介内容
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  padding-bottom: 15px;
}

.title-text {
  font-size: 28px;
  color: #333;
  font-weight: bold;
}

.title-line {
  display: block;
  width: 60px;
  height: 3px;
  background-color: #ff6700;
  margin: 10px auto 0;
}

/* 公司简介特有样式 */
.company-intro {
  padding: 60px 0;
  background-color: #fff;
}

.intro-content {
  max-width: 900px;
  margin: 0 auto;
}

.intro-text {
  line-height: 1.8;
  color: #666;
  margin-bottom: 20px;
  text-indent: 2em;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .title-text {
    font-size: 24px;
  }

  .company-intro {
    padding: 40px 0;
  }

  .intro-text {
    text-indent: 1.5em;
    font-size: 14px;
  }
}
</style>